import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';
import { EmployeeTimeOffAvailabilityRecord, EmployeeTimeOffMode } from '../../../types/EmployeeTimeOff';
import { AVAILABILITY_STATUS_CONFIG, getAvailabilityStatusFromRecords } from '../../../utility/availability';
import {
  availabilityTileDateContainerStyles,
  availabilityTileDotContainerStyles,
  availabilityTileDotStyles,
  availabilityTileInteractiveStyles,
  availabilityTileStatusTextContainerStyles,
  availabilityTileStatusTextStyles,
  tileDayNameStyles,
} from './availabilityPanelStyles';
import { tileContainerStyles } from '../dashboardStyles';

interface AvailabilityTileProps {
  date: DateTime;
  records: EmployeeTimeOffAvailabilityRecord[];
  onClick: (dateKey: string, records: EmployeeTimeOffAvailabilityRecord[]) => void;
}

export function AvailabilityTile({ date, records, onClick }: AvailabilityTileProps) {
  const status = getAvailabilityStatusFromRecords(records);

  const isWeekly = _.some(records, { mode: EmployeeTimeOffMode.WEEKLY });

  const { label, color, backgroundColor } = AVAILABILITY_STATUS_CONFIG[status];

  const dateKey = date.toISODate() || '';

  return (
    <Box
      sx={{
        ...tileContainerStyles,
        ...availabilityTileInteractiveStyles,
        backgroundColor,
      }}
      onClick={() => onClick(dateKey, records)}
    >
      <Box sx={availabilityTileDateContainerStyles}>
        <Typography sx={tileDayNameStyles}>{date.toFormat('ccc').toUpperCase()}</Typography>

        <Typography
          sx={{
            fontWeight: 700,
            fontSize: '1.35rem',
            lineHeight: 1,
          }}
        >
          {date.day}
        </Typography>
      </Box>

      <Box sx={availabilityTileStatusTextContainerStyles}>
        <Typography
          sx={{
            ...availabilityTileStatusTextStyles,
            color,
          }}
        >
          {label}
        </Typography>
      </Box>

      <Box sx={availabilityTileDotContainerStyles}>
        {isWeekly ? (
          <CalendarMonthOutlinedIcon
            sx={{
              color,
              fontSize: 18,
            }}
          />
        ) : (
          <Box
            sx={{
              ...availabilityTileDotStyles,
              bgcolor: color,
            }}
          />
        )}
      </Box>
    </Box>
  );
}
